import React, {useState} from "react";
import styled from "styled-components";

const Container = styled.div`
    flex-grow: 1;
    font-size: ${props => props.fontSize ? props.fontSize : "12px"};
    word-wrap: break-word;
    white-space: pre-line;
    text-overflow: ellipsis;
`;

const WholeText = styled.span`    
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 120px;
    word-wrap: break-word;
    white-space: pre-line;
    text-overflow: ellipsis;
    max-height: fit-content;
    margin-right: 8px;
`;

const ShortText = styled(WholeText)`
    flex-grow: 0;
    overflow-y: hidden;
    height: 42px;
    flex-basis: 42px;
`;

const ViewMoreOrLessButton = styled.span`    
    text-decoration: underline;
    color: #3b7433;
    cursor: pointer;
`;

export const ViewMoreOrLess = ({seeMore, onSeeClick}) => {
    return (
        <ViewMoreOrLessButton onClick={onSeeClick} className="t-see-more-or-less-button">
            {seeMore ? "View Less" : "View More"}
        </ViewMoreOrLessButton>
    );
};

function shorten(lines, formattedText, limit) {
    if (lines.length >= 3) {
        formattedText = `${lines[0]}\n${lines[1]}\n${lines[2]}`.trim();
    }
    return formattedText.substring(0, limit) + "...";
}

export const ExpandableText = ({text, className, onClick, limit = 120, fontSize}) => {
    const [seeMore, setSeeMore] = useState(false);

    if (!text) {
        return null;
    }

    let formattedText = text.trim();
    const lines = formattedText.split('\n');
    if (formattedText.length <= limit && lines.length < 3) {
        return <Container className={className} fontSize={fontSize}>{formattedText}</Container>
    }

    const onSeeClick = () => {
        const seeMoreNewValue = !seeMore;
        onClick(seeMoreNewValue);
        setSeeMore(seeMoreNewValue);
    };

    let descriptionComponent;
    if (seeMore) {
        descriptionComponent = <WholeText className="t-whole-text">{formattedText}</WholeText>
    } else {
        descriptionComponent = <ShortText className="t-short-text">
            {shorten(lines, formattedText, limit)}
        </ShortText>;
    }

    return <Container className={className} fontSize={fontSize}>
        {descriptionComponent}
        <ViewMoreOrLess onSeeClick={onSeeClick} seeMore={seeMore}/>
    </Container>
};